import { ComponentType } from 'react';

import { ExploreCollection } from '@addmile/backend-client';

import { useContentQueries } from '../../services/ContentManagerService';

interface WithCollectionDetailsProps {
  collection: ExploreCollection;
  onEdit: (slug: string) => void;
  onDelete: (slug: string) => void;
}

export function withCollectionDetails<P extends WithCollectionDetailsProps>(
  Component: ComponentType<
    P & { blocksCount?: number; hasMoreBlocks?: boolean; isLoadingBlocksCount?: boolean }
  >,
) {
  return function WithCollectionDetailsComponent(props: P) {
    const { useCollectionDetails } = useContentQueries();
    const { data, isLoading } = useCollectionDetails(props.collection.slug);
    const blocksCount = data?.blocks?.items?.length;

    return (
      <Component
        {...props}
        blocksCount={blocksCount}
        hasMoreBlocks={data?.blocks?.hasMore}
        isLoadingBlocksCount={isLoading}
      />
    );
  };
}
